import { QueryClient } from '@tanstack/react-query';

// Single shared React Query client for every webpack entry (main shell, dr, docservice).
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 0,                    // Data is immediately stale (always refetch)
      gcTime: 1000 * 60 * 5,           // Keep unused data in cache for 5 minutes (garbage collection)
      refetchOnWindowFocus: false,     // Don't refetch when user returns to tab
      retry: 1,                        // Retry failed requests once
    },
  },
});
